/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Pipelines_Stage_Has_ItemsInputs */

const cs_pipelines_stage_has_items = /** @type {(inputs: Pipelines_Stage_Has_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tato fáze obsahuje ${i?.count} položek. Vyberte fázi ve stejné pipeline, kam je přesunout.`)
};

const en_pipelines_stage_has_items = /** @type {(inputs: Pipelines_Stage_Has_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This stage has ${i?.count} items. Choose a stage in this pipeline to move them to.`)
};

/**
* | output |
* | --- |
* | "This stage has {count} items. Choose a stage in this pipeline to move them to." |
*
* @param {Pipelines_Stage_Has_ItemsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_stage_has_items = /** @type {((inputs: Pipelines_Stage_Has_ItemsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Stage_Has_ItemsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_stage_has_items(inputs)
	return cs_pipelines_stage_has_items(inputs)
});